<template>
  <v-list two-line subheader>
    <v-list-item-group v-if="traderSubscriptions">
      <v-list-item v-for="item in traderSubscriptions" :key="item.account.id">
        <v-list-item-action>
          <v-btn
            v-if="item.subscription.id"
            color="primary"
            icon
            text
            :loading="itemLoading === item.subscription.investorAccountId"
            @click="onUnSubscribe(item.subscription)"
          >
            <v-icon>clear</v-icon>
          </v-btn>
          <v-btn
            v-else
            color="primary"
            icon
            text
            :loading="itemLoading === item.subscription.investorAccountId"
            @click="onSubscribe(item.subscription)"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title v-text="item.account.name"></v-list-item-title>
          <v-list-item-subtitle v-text="item.account.id"></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title v-text="item.account.broker"></v-list-item-title>
          <v-list-item-subtitle v-text="item.account.enable ? 'enable' : 'disable'"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
    <v-skeleton-loader v-else boilerplate type="list-item-avatar-three-line" class="mx-auto"></v-skeleton-loader>
  </v-list>
</template>

<script>
import { mapGetters } from "vuex";
import { SUBSCRIPTION, ERROR } from "@/store/actions.type";

export default {
  name: "Subscribe",
  props: {
    traderAccount: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      traderSubscriptions: null,
      subscriptionSchema: {
        id: null,
        snsArn: process.env.VUE_APP_SNS_ARN,
        isTrade: true,
        traderAccountId: null,
        investorAccountId: null,
        userId: null
      },
      itemLoading: null
    };
  },
  computed: {
    ...mapGetters(["currentUser", "accounts", "subscriptions"])
  },
  watch: {
    currentUser(currentUser) {
      this.fetchData(currentUser);
    }
  },
  mounted() {
    this.fetchData(this.currentUser);
  },
  methods: {
    fetchData(currentUser) {
      if (currentUser)
        this.$store.dispatch(SUBSCRIPTION.FETCH, currentUser.id).then(data => {
          this.scanSubscription(this.accounts, data);
        });
    },
    scanSubscription(accounts, subscriptions) {
      const newItems = [];
      if (accounts.length > 0) {
        accounts.forEach(item => {
          let foundSub = subscriptions.find(sub => {
            return (
              sub.traderAccountId === this.traderAccount.id &&
              sub.investorAccountId === item.id
            );
          });
          // add to Account List
          if (foundSub !== undefined) {
            newItems.push({
              account: item,
              subscription: foundSub
            });
          } else {
            newItems.push({
              account: item,
              subscription: {
                id: null,
                snsArn: item.snsArn, //process.env.VUE_APP_SNS_ARN,
                isTrade: true,
                traderAccountId: this.traderAccount.id,
                investorAccountId: item.id,
                userId: this.currentUser.id
              }
            });
          }
        });
        this.traderSubscriptions = newItems.sort(function(a, b) {
          a = a.subscription.id ? 1 : 0;
          b = b.subscription.id ? 1 : 0;
          return b - a;
        });
      }
      return newItems;
    },
    onSubscribe(subscriptionSchema) {
      this.itemLoading = subscriptionSchema.investorAccountId;
      // call api
      this.$store
        .dispatch(SUBSCRIPTION.CREATE, subscriptionSchema)
        .then(data => {
          this.itemLoading = null;
          if (data.status == 200) {
            subscriptionSchema.id = [
              subscriptionSchema.investorAccountId,
              ".",
              subscriptionSchema.traderAccountId
            ].join();
          }
        });
    },
    onUnSubscribe(subscriptionSchema) {
      this.itemLoading = subscriptionSchema.investorAccountId;
      // call api
      this.$store.dispatch(SUBSCRIPTION.DEL, subscriptionSchema).then(data => {
        this.itemLoading = null;
        if (data.status == 200) {
          subscriptionSchema.id = null;
        }
      });
    },
    clearErrors() {
      this.$store.dispatch(ERROR.DEL);
    }
    // onSubscribeTopic(subscriptionSchema) {
    //   this.$store.dispatch(
    //     SUBSCRIPTION.SUBSCRIBE_TOPIC,
    //     process.env.VUE_GOOGLE_TRADING_DESK,
    //     subscriptionSchema.traderAccount.id,
    //     subscriptionSchema.investorAccountId
    //   );
    // }
  }
};
</script>

<style></style>
